import { useMutation } from '@tanstack/react-query';

import API from 'configs/API';
import { axiosPost } from 'utils/apis/axios';

const createShareLinkApi = async ({ payload }) => {
  const { data } = await axiosPost(false, API.ARTWORK.CREATE_SHARE_LINK, payload);

  return data;
};

const useCreateShareLink = () => {
  return useMutation({
    mutationFn: createShareLinkApi,
  });
};

export default useCreateShareLink;
